import React, { useState, useEffect, useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, Button } from "@material-ui/core";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableMarker from "./DraggableMarker";
import DropContainer from "./DropContainer";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderColor: theme.palette.grey[400],
    borderWidth: 3,
    borderStyle: "dashed",
    borderRadius: "10px",
  },
  hintText: {
    fontSize: "14px",
    color: theme.palette.grey[400],
    marginBottom: "20px",
  },
  imageContainer: {
    width: "100%",
    maxWidth: "500px",
  },
  removerButton: {
    // marginRight: "20px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
}));

export default function DifferencePointer({ src, setPoints, points }) {
  const classes = useStyles();
  const [markers, setMarkers] = useState([]);
  const imgRef = useRef(null);
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (markers.length !== 0) {
      let allpoints = [];
      allpoints = markers.map(
        (item) => `${item.x / imgSize.width}|${item.y / imgSize.height}`
      );
      setPoints(allpoints);
    }
  }, [markers]);

  useEffect(() => {
    let tempPoints = [];
    if (imgSize.width > 0 && markers.length !== points.length) {
      points.forEach((el, index) => {
        let temp = {
          id: index + 1,
          x: el.x * imgSize.width,
          y: el.y * imgSize.height,
        };
        tempPoints.push(temp);
      });
      setMarkers(tempPoints);
    }
  }, [imgSize]);

  useEffect(() => {
    const image = imgRef.current;
    if (image) {
      const handleLoad = () => {
        setImgSize({
          width: image.width,
          height: image.height,
        });
      };
      image.addEventListener("load", handleLoad);

      return () => {
        image.removeEventListener("load", handleLoad);
      };
    }
  }, [src, points]);

  const addMarker = useCallback(
    ({ x, y }) => {
      const newMarker = {
        id: markers.length + 1,
        x,
        y,
      };
      setMarkers((prevMarkers) => [...prevMarkers, newMarker]);
    },
    [markers]
  );

  const moveMarker = useCallback((id, x, y) => {
    setMarkers((prevMarkers) =>
      prevMarkers.map((marker) => {
        return marker.id === id ? { ...marker, x, y } : marker;
      })
    );
  }, []);

  return (
    <Box className={classes.container}>
      <Typography className={classes.hintText}>
        برای انتخاب نقاط روی تصویر کلیک کنید
      </Typography>
      <DndProvider backend={HTML5Backend}>
        <DropContainer addMarker={addMarker} moveMarker={moveMarker}>
          <img
            ref={imgRef}
            crossOrigin="anonymous"
            className={classes.imageContainer}
            src={`${baseUrl}file/get/${src}`}
            alt="cover"
          />
          {markers.map((marker, index) => (
            <DraggableMarker
              key={marker.id}
              id={marker.id}
              position={{ x: marker.x, y: marker.y }}
              index={index}
              moveMarker={moveMarker}
            />
          ))}
        </DropContainer>
        {markers.length !== 0 && (
          <Box className={classes.btnContainer}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setMarkers([])}
              className={classes.removerButton}
            >
              پاک کردن تمامی نقاط
            </Button>
          </Box>
        )}
      </DndProvider>
    </Box>
  );
}
